import http from '@/services/http.js';

export const getUploadStatus = async (client_id) => {
  try {
    const response = await http.get(
      `/videoapi/infoUpload/getUploadStatus/${client_id}`
    );
    return response.data;
  } catch (error) {
    console.error('获取上传状态失败', error);
    throw error;
  }
};

export const uploadImages = async (formData) => {
  const response = await http.post(
    `/videoapi/infoUpload/uploadImages`,
    formData
  );
  return response;
};


export const uploadAudio = async (formData, uploadOrReplace) => {
  const response = await http.post(
    `/videoapi/infoUpload/uploadAudio/${uploadOrReplace}`,
    formData
  );
  return response;
};


export const deleteMedia = async (table, id) => {
  const response = await http.delete(
    `/videoapi/infoUpload/deleteMedia/${table}/${id}`
  );
  return response;
};


export const updateFileFieldValue = async (table, filed, id, fieldValue) => {
  const response = await http.put(`/videoapi/infoUpload/updateFileFieldValue`, {
    table,
    filed,
    id,
    fieldValue,
  });
  return response;
};


export const generateAudio = async (formData) => {
  const response = await http.post(
    `/videoapi/automationFlow/generateAudio`,
    formData
  );
  return response;
};


export const regenerateAudio = async (
  batch_id,
  id,
  new_sentence_text,
  text_type,
  client_id,
  blank
) => {
  const response = await http.post(`/videoapi/automationFlow/regenerateAudio`, {
    batch_id,
    id,
    new_sentence_text,
    text_type,
    client_id,
    blank,
  });
  return response;
};


export const getAIAudios = async (batch_id) => {
  try {
    const response = await http.get(
      `/videoapi/infoUpload/getAIAudios/${batch_id}`
    );
    return response.data;
  } catch (error) {
    console.error('获取AI音频失败', error);
    throw error;
  }
};


export const downloadAudio = async (
  audioUrls,
  client_id,
  audio_type,
  batchId
) => {
  const response = await http.post(`/videoapi/automationFlow/downloadAudio`, {
    audioUrls,
    client_id,
    audio_type,
    batchId,
  });
  return response;
};


export const downloadOriginalZip = async (images, client_id) => {
  try {
    const response = await http.post(
      '/videoapi/infoUpload/downloadOriginalZip',
      { images, client_id },
      { responseType: 'blob' }
    );
    return response.data;
  } catch (error) {
    console.error('批量下载原图失败', error);
    throw error;
  }
};


export const downloadInfo = async (
  client_id,
  user_companyName,
  clientName,
  ceremonyDate,
  videoType
) => {
  try {
    const response = await http.get(
      `/videoapi/infoUpload/downloadInfo/${client_id}`
    );

    if (response.status === 200 && response.data.success) {
      const { task_id, failedImages } = response.data;

      // 第二步：通过 taskId 下载文件
      const downloadResponse = await http.get(
        `/videoapi/infoUpload/download/${task_id}`,
        {
          responseType: 'blob', // 确保接收的是二进制数据
        }
      );

      // 创建一个临时的 URL 对象来表示二进制数据
      const url = window.URL.createObjectURL(new Blob([downloadResponse.data]));
      const link = document.createElement('a');
      link.href = url;

      // 设置默认文件名
      let filename = `${user_companyName}_${clientName}_${ceremonyDate}_${videoType}.zip`;

      link.setAttribute('download', filename);

      // 触发下载
      document.body.appendChild(link);
      link.click();

      // 清理临时 URL 和 DOM 元素
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      // 关键：返回 failedImages 给页面
      return { failedImages: failedImages || [] };
    } else {
      console.error('文件生成失败:', response.data.message);
      throw new Error(response.data.message || '文件生成失败');
    }
  } catch (error) {
    console.error('下载信息失败', error);
    throw error;
  }
};


export const retryFixImage = async (image_url, image_id, client_id) => {
  try {
    const response = await http.post('/videoapi/infoUpload/image/fix', {
      image_url,
      image_id,
      client_id,
    });

    if (response.data.status !== 200 || !response.data.success) {
      return {
        success: false,
        error: response.data.error || response.data.message || '图片修复失败',
      };
    }

    return {
      success: true,
      fixedUrl: response.data.fixedUrl,
    };
  } catch (error) {
    console.error('图片修复失败', error);
    return {
      success: false,
      error:
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        '图片修复失败',
    };
  }
};

// 批量下载原图zip

